export type UpsertType =
    | "on-conflict-do-update"
    | "on-duplicate-key-update"
    | "primary-key"
    | "merge-into"
